class CustomDropdown {
  private dropdowns: HTMLElement[] = [];
  constructor() {
    this.dropdowns = Array.from(document.querySelectorAll('.custom-dropdown'));
    this.init();
  }

  clickOutside(event: MouseEvent) {
    if (!this.dropdowns.includes(event.target as HTMLElement)) {
      this.dropdowns.forEach((dropdown) => {
        dropdown.classList.remove('custom-dropdown--active');
      });
    }
  }

  init() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.querySelector('.custom-dropdown__head')?.addEventListener('click', (e : Event) => {
        e.preventDefault();
        e.stopPropagation();
        dropdown.classList.toggle('custom-dropdown--active');
      });
    });
    document.addEventListener('click', (e) => {
      this.clickOutside(e as MouseEvent);
    });
  }
}

export default function customDropdown() {
  return new CustomDropdown();
}


